var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F3F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4587 30.3334C22.4587 29.8501 22.8504 29.4584 23.3337 29.4584L32.667 29.4584C33.1502 29.4584 33.542 29.8501 33.542 30.3334C33.542 30.8166 33.1502 31.2084 32.667 31.2084L23.3337 31.2084C22.8504 31.2084 22.4587 30.8166 22.4587 30.3334Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4587 25.6667C22.4587 25.1834 22.8504 24.7917 23.3337 24.7917H25.667C26.1502 24.7917 26.542 25.1834 26.542 25.6667C26.542 26.1499 26.1502 26.5417 25.667 26.5417H23.3337C22.8504 26.5417 22.4587 26.1499 22.4587 25.6667Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4587 35C22.4587 34.5168 22.8504 34.125 23.3337 34.125H28.0003C28.4836 34.125 28.8753 34.5168 28.8753 35C28.8753 35.4833 28.4836 35.875 28.0003 35.875H23.3337C22.8504 35.875 22.4587 35.4833 22.4587 35Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.667 14.2917C26.1502 14.2917 26.542 14.6834 26.542 15.1667V19.8334C26.542 20.3166 26.1502 20.7084 25.667 20.7084C25.1837 20.7084 24.792 20.3166 24.792 19.8334V18.375H21.0003C20.1949 18.375 19.542 19.0279 19.542 19.8334V37.3334C19.542 38.1388 20.1949 38.7917 21.0003 38.7917H35.0003C35.8057 38.7917 36.4587 38.1388 36.4587 37.3334V19.8334C36.4587 19.0279 35.8057 18.375 35.0003 18.375H30.917C30.4337 18.375 30.042 17.9833 30.042 17.5C30.042 17.0168 30.4337 16.625 30.917 16.625H35.0003C36.7722 16.625 38.2087 18.0614 38.2087 19.8334V37.3334C38.2087 39.1053 36.7722 40.5417 35.0003 40.5417H21.0003C19.2284 40.5417 17.792 39.1053 17.792 37.3334V19.8334C17.792 18.0614 19.2284 16.625 21.0003 16.625H24.792V15.1667C24.792 14.6834 25.1837 14.2917 25.667 14.2917Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyNotes);
export default __webpack_public_path__ + "static/media/iconEmptyNotes.eaa28662dff0dea04ab6517041891537.svg";
export { ForwardRef as ReactComponent };